import moment from 'moment'

export default (value) => {
    let date = value.split(':');
    date[date.length - 1] = '00';
    value = date.join(':');
    return new moment(value).format('YYYY-MM-DD HH:mm:ss');
}
